import $ from 'jquery';
import 'slick-carousel';

// Model Overview "Explore the <Model>" slider: centre image with the
// neighbouring images peeking in at the sides.
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

$('.model-rotator').each(function () {
  const sliderID = $(this).data('slider');
  const $rotatorSlider = $(`.${sliderID}`);
  const withPreviews = $rotatorSlider.children().length >= 3;

  $rotatorSlider.on('init reInit afterChange', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.slide-m-dots-${sliderID}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $rotatorSlider.slick({
    centerMode: withPreviews,
    centerPadding: withPreviews ? '20%' : '0px',
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: true,
    infinite: true,
    arrows: false,
    dots: true,
    appendDots: $(`.slide-m-dots-${sliderID}`),
    autoplay: !reduceMotion,
    autoplaySpeed: 4500,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerPadding: withPreviews ? '12%' : '0px',
        },
      },
    ],
  });
});
